import store from "../store";
const { userHasPermission, userHasRole } = require("./userState");

export const hasRole = (...args) => {
  return userHasRole(store.getters.getUser, args);
};

export const hasPermission = (...args) => {
  return userHasPermission(store.getters.getUser, args);
};
